// Erreurs du Python du lycée (refonte lot 5.7) : un code stable et un message en français.

export type PyErrorCode =
  | 'syntax'
  | 'name'
  | 'type'
  | 'zero_division'
  | 'index'
  | 'value'
  | 'budget'
  | 'recursion'
  | 'unsupported'
  | 'inexact';

export class PyError extends Error {
  constructor(
    readonly code: PyErrorCode,
    message: string,
    readonly line: number,
  ) {
    super(message);
    this.name = 'PyError';
  }
}
